import { render, staticRenderFns } from "./deliveries.vue?vue&type=template&id=8b0ff560"
import script from "./deliveries.vue?vue&type=script&lang=js"
export * from "./deliveries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports